import { ChangeDetectionStrategy, Component, computed, input, model, output, ViewEncapsulation } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { Workflow } from "../service/Workflow";
import { WorkflowActionInputComponent } from "./workflow.action.input.component";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-create-event-action",
    template: `
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['eventName']?.inputValue"
            (valueChange)="setInputValue('eventName', $event)"
            [label]="'Event Name'"
            [type]="'text'"
            [required]="true"
            [help]="'Use field variables like $CNET-123-EVENT_NAME'"
        />
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['startDate']?.inputValue"
            (valueChange)="setInputValue('startDate', $event)"
            [label]="'Start Date'"
            [type]="'text'"
            [required]="true"
            [help]="'Use field variables like $CNET-123-START_DATE'"
        />
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['endDate']?.inputValue"
            (valueChange)="setInputValue('endDate', $event)"
            [label]="'End Date'"
            [type]="'text'"
            [required]="true"
            [help]="'Use field variables like $CNET-123-END_DATE'"
        />
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['eventTypeId']?.inputValue"
            (valueChange)="setInputValue('eventTypeId', $event)"
            [label]="'Event Type ID'"
            [type]="'text'"
            [required]="true"
            [help]="'Use field variables like $CNET-123-EVENT_TYPE_ID'"
        />
        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['primaryOrgId']?.inputValue"
            (valueChange)="setInputValue('primaryOrgId', $event)"
            [label]="'Primary Organization ID'"
            [type]="'text'"
            [required]="true"
            [help]="'Use field variables like $CNET-123-ORG_ID'"
        />
    `,
    styles: `
        .system-input {
            margin-bottom: 16px;
        }

        .system-input:last-child {
            margin-bottom: 0;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ReactiveFormsModule, WorkflowActionInputComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateEventActionComponent {
    readonly inputs = model.required<Workflow.WorkflowActionInput[]>();
    readonly inputIdGenerator = input.required<() => number>();

    readonly changed = output<void>();

    readonly inputMap = computed(() => Object.fromEntries(this.inputs().map((input) => [input.inputCode, input])));

    setInputValue(inputCode: string, value: string) {
        let input = this.inputs().find((input) => input.inputCode === inputCode);
        if (!input) {
            input = {
                id: this.inputIdGenerator()(),
                inputCode: inputCode,
                inputValue: value,
            };
            this.inputs.update((inputs) => [...inputs, input]);
        } else {
            input.inputValue = value;
        }
        this.changed.emit();
    }
}
